import { getProject } from '../../common/services/project';

export const getCompetitionHref = (
  competitionAreaSlug: string,
  competitionSlug: string
): string =>
  `#${getProject().url}/competitions/${competitionAreaSlug}/${competitionSlug}`;

  export const getCompetitionsHref = (): string => `#${getProject().url}/competitions`;
